// Parts shared by the redesigned pages.
import React from 'react';
import './ParcelManager.css';

export const toNumber = (value) => parseFloat(value) || 0;
export const formatHa = (value) => toNumber(value).toFixed(2);
export const nameOf = (option) => (typeof option === 'string' ? option : option?.name || '');

export const formatDate = (value) => {
  if (!value || value === 'N/A') return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString('ro-RO');
};

export const contractExpiry = (value) => {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return null;
  date.setFullYear(date.getFullYear() + 10);
  return date;
};

export const expiresWithinTwoYears = (value) => {
  const expiry = contractExpiry(value);
  if (!expiry) return false;
  const limit = new Date();
  limit.setFullYear(limit.getFullYear() + 2);
  return expiry <= limit;
};

export const Field = ({ label, error, hint, children }) => (
  <label className={`pm-field ${error ? 'has-error' : ''}`}>
    <span>{label}</span>
    {children}
    {hint && <small>{hint}</small>}
  </label>
);

export const Icon = ({ d, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={d} /></svg>
);

export const ICON = {
  close: 'M6 6l12 12M18 6L6 18',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  search: 'M11 18a7 7 0 100-14 7 7 0 000 14zM20 20l-4-4',
  trash: 'M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13',
  edit: 'M4 20h4L19 9l-4-4L4 16zM13 7l4 4',
  doc: 'M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h6',
  back: 'M15 5l-7 7 7 7',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  print: 'M7 8V3h10v5M7 17H4v-7a2 2 0 012-2h12a2 2 0 012 2v7h-3M7 14h10v7H7z',
  tag: 'M3 12V4h8l10 10-8 8zM8 8h.01',
  chart: 'M5 20V10M12 20V4M19 20v-7',
  table: 'M3 5h18v14H3zM3 10h18M3 15h18M9 5v14',
  play: 'M12 5v14M5 12h14',
  clock: 'M12 7v5l3 2M12 21a9 9 0 100-18 9 9 0 000 18z',
};

// A full-height panel on a phone, a centered one on a computer.
export const Panel = ({ title, subtitle, onClose, footer, children, onSubmit, className = '' }) => {
  const Body = onSubmit ? 'form' : 'div';
  return (
    <div className={`pm-overlay ${className}`} onClick={(e) => e.target === e.currentTarget && onClose?.()}>
      <Body className="pm-panel" role="dialog" aria-modal="true" aria-label={title} onSubmit={onSubmit} noValidate={onSubmit ? true : undefined}>
        <header className="pm-panel-head">
          <button type="button" className="pm-icon-btn" aria-label="Închide" onClick={onClose}><Icon d={ICON.close} size={18} /></button>
          <div className="pm-panel-title">
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
        </header>
        <div className="pm-panel-body">{children}</div>
        {footer && <footer className="pm-panel-foot">{footer}</footer>}
      </Body>
    </div>
  );
};

export const ConfirmPanel = ({ title, text, action, onYes, onClose }) => (
  <Panel title={title} onClose={onClose} className="pm-confirm"
    footer={(
      <>
        <button type="button" className="pm-btn-soft" onClick={onClose}>Înapoi</button>
        <button type="button" className="pm-btn-soft pm-danger" onClick={onYes}>{action}</button>
      </>
    )}>
    <p>{text}</p>
  </Panel>
);
